export default __webpack_public_path__ + "static/media/pause.d888c081.svg";